'use client';

import { c as _c } from "react/compiler-runtime";
import { useConstant } from '@cc-shopping/hooks/useConstant';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { FullBleedBox } from '@cc-shopping/ui/primitives/FullBleedBox';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import { Box, Typography } from '@mui/material';
import { v4 as uuid } from 'uuid';
import { SparkleIcon } from '../ByBranch/SparkleIcon';
import { BranchButton } from './BranchButton';
import { CreditometerIcon } from './CreditometerIcon';
import { BRANCH_AGNOSTIC_CONTENT, BRANCH_BUTTONS, ENTRYPOINT_ENTITY_NAME, ENTRYPOINT_SECTION_NAME } from './constants';
import { GetMatchedButton } from './GetMatchedButton';
export function CardFinderBranchAgnosticEntrypoint() {
  const $ = _c(26);
  const activityId = useConstant(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      gap: 3,
      paddingY: {
        xs: "2rem",
        sm: 6
      }
    };
    t1 = <SparkleIcon />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      gap: "1.5rem"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: {
        xs: "24px",
        sm: "30px"
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: "inherit",
      color: "common.white"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Box sx={t3}><Typography component="p" variant="smallHeadline" id="branch-agnostic-entrypoint-heading" sx={t4}>{BRANCH_AGNOSTIC_CONTENT.headlineLead}{" "}<Typography component="span" variant="smallHeadline" sx={{
          fontSize: "inherit",
          color: "lime.tintLP"
        }}>{BRANCH_AGNOSTIC_CONTENT.headlineHighlight}</Typography></Typography></Box>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={t2}>{t5}<Typography component="h2" variant="text" sx={{
        color: "lime.tintLP",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        fontSize: 12
      }}>{BRANCH_AGNOSTIC_CONTENT.eyebrow}</Typography></Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      flexWrap: "wrap",
      gap: 1.5
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== activityId) {
    t8 = BRANCH_BUTTONS.map((config, position) => <BranchButton key={config.branch} activityId={activityId} config={config} position={position} />);
    $[8] = activityId;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== activityId) {
    t9 = <GetMatchedButton activityId={activityId} />;
    $[10] = activityId;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <Box sx={t7}>{t8}{t9}</Box>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <BoltOutlinedIcon sx={{
      fontSize: 18,
      color: "lime.tintLP"
    }} aria-hidden={true} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Typography variant="text" sx={{
      color: "common.white",
      fontSize: 12
    }}>{BRANCH_AGNOSTIC_CONTENT.footnoteMinutes}</Typography>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Typography variant="text" sx={{
      color: "common.white",
      fontSize: 12,
      mx: 0.5
    }}>·</Typography>;
    t15 = <CreditometerIcon aria-hidden={true} />;
    $[18] = t14;
    $[19] = t15;
  } else {
    t14 = $[18];
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Box sx={t11}>{t12}{t13}{t14}{t15}<Typography variant="text" sx={{
        color: "common.white",
        fontSize: 12
      }}>{BRANCH_AGNOSTIC_CONTENT.footnoteNoImpact}</Typography></Box>;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t10) {
    t17 = <FullBleedBox component="aside" aria-labelledby="branch-agnostic-entrypoint-heading" data-testid="cardfinder_branch_agnostic_banner" background="linear-gradient(115deg, #015538 8.49%, #006642 61.88%, #008254 91.51%)" sx={t0}>{t1}{t6}{t10}{t16}</FullBleedBox>;
    $[21] = t10;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== activityId || $[24] !== t17) {
    t18 = <FeatureViewed entityName={ENTRYPOINT_ENTITY_NAME} entitySection={ENTRYPOINT_SECTION_NAME} impressionPosition={0} activityId={activityId}>{t17}</FeatureViewed>;
    $[23] = activityId;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
}
function _temp() {
  return uuid();
}